export default __webpack_public_path__ + "static/media/Information.51375011.svg";